// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistLandingNavbar-cls1_74b","cls2":"CoScientistLandingNavbar-cls2_0iR CoScientistLandingNavbar-cls1_74b","compact":"CoScientistLandingNavbar-compact_XrF"};